export default class VehicleModule {
    
}
